import builder from '../builder';
import UiWebpageCheck from '../../streamline-icons/light/ui-webpage-check.svg';

export default builder('IconUiWebpageCheckLight', UiWebpageCheck);
